import MuiCheckbox from "@mui/material/Checkbox";
import type { MenuItemProps as MuiMenuItemProps } from "@mui/material/MenuItem";
import MuiMenuItem from "@mui/material/MenuItem";
import { Typography } from "../../General";

export interface SelectItemProps
    extends Pick<MuiMenuItemProps, "disabled" | "onClick" | "selected"> {
    value: string;
    children: string;
}

export function SelectMultipleItem({
    disabled,
    children,
    onClick,
    selected,
    value,
}: SelectItemProps) {
    return (
        <MuiMenuItem disabled={disabled} onClick={onClick} selected={selected} value={value}>
            <MuiCheckbox checked={selected} disabled={disabled} />
            <Typography>{children}</Typography>
        </MuiMenuItem>
    );
}
